// extracted by mini-css-extract-plugin
module.exports = {"review":"styles_review__3tbJZ","flex":"styles_flex__2XroL","expert":"styles_expert__1u0s7","btn":"styles_btn__oCuhe"};